import React from 'react';
import useWindowSize from "./useWindowSize";

const useSize375 = () => {
    return window.innerWidth/375;
};

export default useSize375;